import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  AbstractControl,
} from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Observable, SubscriptionLike } from 'rxjs';
import {
  getPlacedSkuDetail,
  getPlanogramImageUrl,
  noWhitespaceValidator,
} from 'src/helper/app-utils';
import {
  PlanogramBaseDetailModal,
  SKUModal,
  PlanogramBaseDetailInfo,
  PlanogramSegmentEntityModal,
  ScreenDataModal,
  coolerDataInterface,
  PlanogramNPDDetailInfo,
} from 'src/modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { ConfirmDialogModalComponent } from '../confirm-dialog-modal/confirm-dialog-modal.component';
import { CONFIG } from 'src/helper/app-config';
import { AzureBlobStorageService } from 'src/services/azure-blob-storage.service';
import { MatSelectChange } from '@angular/material/select';
import { environment } from 'src/environments/environment';
import { GuidelinesInputComponent } from '../guidelines-input/guidelines-input.component';
import { PlanogramService } from 'src/services/planogram.service';

@Component({
  selector: 'app-setup-planogram',
  templateUrl: './setup-planogram.component.html',
  styleUrls: ['./setup-planogram.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class SetupPlanogramComponent implements OnInit {
  CONFIG = CONFIG;
  @ViewChild(GuidelinesInputComponent)
  guidelinesInputComponent!: GuidelinesInputComponent;
  sku_placement_change: boolean = false;
  create_new_template: boolean = false;
  stepper_index: number = 0;

  temp_stepper_index: number = 0;
  is_save_detail_and_nevigate: boolean = false;

  planogram_base_detail_form_group: FormGroup;

  cooler_template_form_group: FormGroup = this._formBuilder.group({
    cooler_template: new FormControl('', Validators.required),
  });
  add_sku_form_group: FormGroup = this._formBuilder.group({
    filled_sku: new FormControl(0, [Validators.required, Validators.min(80)]),
    volume: new FormControl(0),
    profit: new FormControl(0),
    revenue: new FormControl(0),
    transaction: new FormControl(0),
  });
  isReset: boolean = false;
  isValidPlan: boolean = true;
  mode: any;
  edit_template_id = -1;
  cooler_template_search_input = '';
  is_planogram_edit: boolean;
  edit_planogram_detail: any;
  planogram_placed_skus: SKUModal[] = [];
  picos_sku_list: SKUModal[] = [];
  planogram_image_url: string = '';
  planogram_status: string = '';
  saved_templates: any[] = [];
  temp_planogram_base_details: PlanogramBaseDetailInfo = {};
  temp_npd_data: any = undefined;
  npd_data_with_facings: any = [];
  units: string[] = [];
  channels: string[];
  coolers: string[];
  npd_selections: string[];
  npds_max_message: string = '';
  maximum_npds_allowed: number;
  vertical_brand_association: any = {};
  vertical_cooler_orientation: boolean = false;
  is_go_back: boolean = false;
  cooler_images: any;
  planogram_base_details_subscription: SubscriptionLike;
  npd_data_subscription: SubscriptionLike;
  selected_planogram_base_data_subscription: SubscriptionLike;
  next_event_api_response_subscription: SubscriptionLike;
  is_planogram_edit_subscription: SubscriptionLike;
  edit_planogram_detail_subscription: SubscriptionLike;
  planogram_placed_skus_subscription: SubscriptionLike;
  picos_sku_list_subscription: SubscriptionLike;
  cooler_template_form_subscription: SubscriptionLike;
  saved_templates_subscription: SubscriptionLike;
  throughput_metrics_subscription: SubscriptionLike;
  screen_data_subscription: SubscriptionLike;
  cooler_info_subscribtion: SubscriptionLike;
  // review_lhs_sku_list_subscription: SubscriptionLike
  npd_facing: Record<string, number> = {};
  is_show_loader: Observable<boolean> = this.planogramState.loader;
  planogram_name_error: Observable<string> =
    this.planogramState.planogram_name_error;
  planogram_base_details: Observable<PlanogramBaseDetailInfo> =
    this.planogramState.planogram_base_details;
  npd_data: Observable<Object> = this.planogramState.npd_data;
  is_planogram_edit_observable: Observable<boolean> =
    this.planogramState.is_planogram_edit;
  edit_planogram_detail_observable: Observable<any> =
    this.planogramState.edit_planogram_detail;
  saved_templates_observable: Observable<Object> =
    this.planogramState.saved_templates;
  selected_planogram_base_data: Observable<Object> =
    this.planogramState.selected_planogram_base_data;
  next_event_api_response: Observable<boolean> =
    this.planogramState.next_event_api_response;
  planogram_placed_skus_subscriber: Observable<SKUModal[]> =
    this.planogramState.planogram_placed_skus;
  picos_sku_list_observable: Observable<SKUModal[]> =
    this.planogramState.picos_skus;
  throughput_metrics_observer: Observable<any> =
    this.planogramState.throughput_metrics;
  screen_data: Observable<ScreenDataModal[]> =
    this.planogramState.specific_screen_data;
  cooler_info_observable: Observable<coolerDataInterface> =
    this.planogramState.cooler_info;
  cooler_info: any;
  cooler_info_updated: any;
  review_completed = true;
  screen_index_completed = 0;
  npds_data_valid: boolean = false;
  isSetUpScreenDisabled: boolean = false;
  // review_lhs_sku_list_observable:Observable<any>=
  // this.planogramState.review_lhs_sku_list
  // review_lhs_sku_list_data:any;

  @HostListener('window:beforeunload') saveSkusState() {
    // if (this.stepper_index === 1 && this.sku_placement_change) {
    //   this.savePlanogramSkuPlacement(
    //     this.edit_planogram_detail,
    //     this.stepper_index
    //   );
    // }
  }

  constructor(
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder,
    private planogramState: PlanogramStateService,
    public dialog: MatDialog,
    private blobService: AzureBlobStorageService,
    public apiService: PlanogramService
  ) {
    this.planogramState.getBaseData();
    // this.planogramState.getSpecificScreenData([
    //   'brandchartcolor',
    //   'categorychartcolor',
    // ]);
    let planogram_id;
    this.activatedRoute.params.subscribe((params) => {
      planogram_id = params['planogram_id'];
      if (planogram_id == undefined) {
        sessionStorage.setItem('mode', 'new');
      }
      if (planogram_id !== undefined && planogram_id !== -1) {
        this.planogramState.setPlanogramEdit(true, planogram_id);
      }
      this.mode = sessionStorage.getItem('mode');
    });

    const router_state = this.router.getCurrentNavigation()?.extras.state;
    this.isSetUpScreenDisabled = router_state?.['from'] === 'library';
    if (planogram_id && localStorage.getItem('stepper_index')) {
      this.stepper_index = Number(localStorage.getItem('stepper_index'));
    } else if (router_state) {
      console.log('router_state', router_state);
      this.stepper_index = router_state['screen_index']
        ? router_state['screen_index']
        : this.stepper_index;
    }
    console.log('router_state', router_state);
    localStorage.setItem('stepper_index', String(this.stepper_index));

    let planogram_name = '',
      planogram_name_disable = false,
      npd_selection = '',
      channel = '',
      units = '',
      cooler_type = '',
      portfolio_selection: number[] = [],
      business_goals: number[] = [];

    this.planogram_base_detail_form_group = this._formBuilder.group({
      // planogram_name: new FormControl(
      //   { value: planogram_name, disabled: planogram_name_disable },
      //   [
      //     Validators.required,
      //     Validators.pattern(/^[A-Za-z0-9_]+$/),
      //   ]
      // ),
      channel: new FormControl(
        { value: channel, disabled: true },
        Validators.required
      ),
      units: new FormControl(
        { value: units, disabled: true },
        Validators.required
      ),
      cooler_type: new FormControl(
        { value: cooler_type, disabled: true },
        Validators.required
      ),
      portfolio_selection: new FormControl(
        { value: portfolio_selection, disabled: true },
        Validators.required
      ),
      business_goals: new FormControl(
        { value: business_goals, disabled: true },
        Validators.required
      ),
      npd_selection: new FormControl({ value: npd_selection, disabled: true }),
    });

    this.planogram_base_detail_form_group
      .get('units')
      ?.valueChanges.subscribe((value) => {
        if (value.length == 0) {
          this.planogram_base_detail_form_group.controls['channel'].disable();
          this.planogram_base_detail_form_group.controls[
            'cooler_type'
          ].disable();
        }
        if (value) {
          this.planogram_base_detail_form_group.controls['channel'].enable();
          this.planogram_base_detail_form_group.controls[
            'cooler_type'
          ].enable();
        }
      });

    this.planogram_base_detail_form_group
      .get('channel')
      ?.valueChanges.subscribe((value) => {
        if (value.length == 0) {
          this.planogram_base_detail_form_group.controls[
            'cooler_type'
          ].disable();
        }
        if (value) {
          this.planogram_base_detail_form_group.controls[
            'cooler_type'
          ].enable();
        }
      });
    this.planogram_base_detail_form_group
      .get('cooler_type')
      ?.valueChanges.subscribe((value) => {
        if (value.length == 0) {
          this.planogram_base_detail_form_group.controls[
            'npd_selection'
          ].disable();
        }
        if (value) {
          this.planogram_base_detail_form_group.controls[
            'npd_selection'
          ].enable();
        }
      });
  }

  ngOnInit() {
    this.subscribeFormControls();
    this.selectedPlanogramBaseDataSubscription();
    this.npd_selections = Object.keys(CONFIG.NPD_SELECTION_OPTIONS);
    this.is_planogram_edit_subscription =
      this.is_planogram_edit_observable.subscribe((is_edit) => {
        this.is_planogram_edit = is_edit;
      });
    this.edit_planogram_detail_subscription =
      this.edit_planogram_detail_observable.subscribe((detail) => {
        this.edit_planogram_detail = detail;
      });
    this.saved_templates_subscription =
      this.saved_templates_observable.subscribe((templates) => {
        this.saved_templates = Object.values(templates);
      });
    this.next_event_api_response_subscription =
      this.next_event_api_response.subscribe((api_res) => {
        console.log('api_res', api_res);
        if (api_res) {
          if (this.stepper_index !== this.temp_stepper_index) {
            this.is_save_detail_and_nevigate = false;
            this.updateStepperIndex(
              this.temp_stepper_index,
              this.is_planogram_edit,
              this.edit_planogram_detail,
              this.temp_stepper_index > this.stepper_index
            );
          } else if (this.is_go_back) {
            this.is_go_back = false;
            this.goBack();
          }
          this.planogramState.setNextEventAPIResponse(false);
        }
      });

    this.planogram_placed_skus_subscription =
      this.planogram_placed_skus_subscriber.subscribe((skus) => {
        this.planogram_placed_skus = skus;
      });

    this.cooler_template_form_subscription =
      this.cooler_template_form_group.valueChanges.subscribe((_v) => {
        if (this.cooler_template_form_group.valid) {
          let scenario = this.getScenario();
          this.planogramState.getPicosSKUsList(
            this.edit_planogram_detail.id,
            scenario
          );
        }
      });

    // this.review_lhs_sku_list_subscription=this.review_lhs_sku_list_observable.subscribe(res=>{
    //   if(res){
    //     this.review_lhs_sku_list_data=res
    //   }
    //  })

    this.picos_sku_list_subscription = this.picos_sku_list_observable.subscribe(
      (list) => {
        this.picos_sku_list = list;
      }
    );

    this.throughput_metrics_subscription =
      this.throughput_metrics_observer.subscribe((throughput) => {
        if (throughput && throughput.length > 0) {
          this.add_sku_form_group.get('volume')?.setValue(throughput[0].volume);
          this.add_sku_form_group
            .get('revenue')
            ?.setValue(throughput[0].revenue);
          this.add_sku_form_group.get('profit')?.setValue(throughput[0].profit);
          this.add_sku_form_group
            .get('transaction')
            ?.setValue(throughput[0].transaction);
        }
      });
    this.listenScreenConfig();
  }

  ngOnDestroy() {
    this.planogram_base_details_subscription.unsubscribe();
    this.selected_planogram_base_data_subscription.unsubscribe();
    this.next_event_api_response_subscription.unsubscribe();
    this.is_planogram_edit_subscription.unsubscribe();
    this.edit_planogram_detail_subscription.unsubscribe();
    this.saved_templates_subscription.unsubscribe();
    this.planogramState.setPlanogramEdit(false, -1);
    localStorage.removeItem('stepper_index');
    localStorage.removeItem('channel');
    this.planogram_status = '';
    this.sku_placement_change = false;
    this.planogramState.clearPlanogramNameError();
  }

  listenScreenConfig = () => {
    this.screen_data_subscription = this.screen_data.subscribe((sc) => {
      let chart_color_config = {};
      sc.forEach((ob) => {
        if (ob.key === 'brandchartcolor' || ob.key === 'categorychartcolor') {
          chart_color_config = {
            ...chart_color_config,
            ...{ [ob.key]: JSON.parse(ob.value) },
          };
        }
      });
      if (Object.keys(chart_color_config).length > 0) {
        this.planogramState.setChartColorConfig(chart_color_config);
      }
    });
  };
  handleNPDSelection() {
    let isNPDSelected =
      this.planogram_base_detail_form_group.controls['npd_selection'].value;
    localStorage.setItem('isNPDSelected', isNPDSelected);
  }
  getScenario(_channel?: string) {
    return 'primary_key';
  }

  getNPDData() {
    let selectedUnit: string =
      this.planogram_base_detail_form_group.controls['units'].value;
    let selectedChannel: string =
      this.planogram_base_detail_form_group.controls['channel'].value;
    let selectedCooler: string =
      this.planogram_base_detail_form_group.controls['cooler_type'].value;
    let isNPDSelected =
      this.planogram_base_detail_form_group.controls['npd_selection'].value;
    let body_params = {
      channel: selectedChannel,
      cooler_type: selectedCooler,
      unit: selectedUnit,
      npd_selection:
        CONFIG.NPD_SELECTION_OPTIONS[
          isNPDSelected as keyof typeof CONFIG.NPD_SELECTION_OPTIONS
        ],
    };
    this.planogramState.getBaseNPDData(body_params);
    this.subscribeNPDData();
  }

  displayCoolerValue(data: any, type?: string): any[] {
    let values: any = Object.values(data);
    if (type == 'Shelf Config') {
      return Object.keys(data);
    } else if (values.length > 1) {
      let multiValues = [];
      for (let key in data) {
        multiValues.push(`${data[key]}(${key})`);
      }
      return multiValues;
    } else return Object.values(data);
  }

  getValuesInAObject(obj: any): any {
    return Object.values(obj);
  }

  getImages(obj: any) {
    const values: string[] = Object.values(obj); // Extract URLs from the object
    let imageArray: any = []; // Initialize the cooler_images array
    // Iterate through each image URL
    imageArray=values.map((v:any)=>"loading")
    for (let i=0;i<values.length;i++) {
      this.apiService.fetchImageFromBlob(values[i]).subscribe({
        next: (res: any) => {
          // Adjust the type as needed (e.g., 'image/png')
          const imageUrl = URL.createObjectURL(res); // Create a URL for the Blob
          imageArray[i]=imageUrl; // Push the fetched image to cooler_images
        },
        error: (error) => {
          console.log('Error fetching image:', error);
        },
      });
    }
    this.cooler_images = imageArray;
  }

  subscribeNPDData = () => {
    this.npd_data_subscription = this.npd_data.subscribe((data: any) => {
      if (data.data) {
        let npds = data.data.NPDs;
        for (let i = 0; i < npds.length; i++) {
          npds[i].facings = 0;
        }
        this.temp_npd_data = data.data;
        this.npd_data_with_facings = npds;
        let selected_cooler =
          this.planogram_base_detail_form_group.controls[
            'cooler_type'
          ].value.trim();
        this.maximum_npds_allowed = data.data.maximum_facings[selected_cooler];
        this.npds_max_message = `${this.maximum_npds_allowed} NPD facing allowed`;
        this.checkNpdsMinAndMax();
      }
    });
  };

  increment(i: number, key: string): void {
    this.npd_data_with_facings = this.npd_data_with_facings.map(
      (n: any, index: number) => {
        if (i == index) {
          n.facings++;
        }
        return n;
      }
    );
    this.checkNpdsMinAndMax();
  }

  // checkNpdMinMax() {
  //   let totalSum = 0;
  //   let isValid = true;
  //   for (const value of Object.values(this.npd_facing)) {
  //     if (typeof value === 'number') {
  //       totalSum += value;
  //     }
  //     if (value === 1 && isValid) isValid = false;
  //   }
  //   if (
  //     this.planogram_base_detail_form_group.controls['cooler_type'].value ===
  //     CONFIG.COOLER.CASER12
  //   ) {
  //     if (totalSum > 2) this.isValidPlan = false;
  //     else if (!isValid) this.isValidPlan = false;
  //     else this.isValidPlan = true;
  //   } else if (
  //     this.planogram_base_detail_form_group.controls['cooler_type'].value ===
  //     CONFIG.COOLER.CASER15
  //   ) {
  //     if (totalSum > 2) this.isValidPlan = false;
  //     else if (!isValid) this.isValidPlan = false;
  //     else this.isValidPlan = true;
  //   } else if (
  //     this.planogram_base_detail_form_group.controls['cooler_type'].value ===
  //     CONFIG.COOLER.CASER30
  //   ) {
  //     if (totalSum > 4) this.isValidPlan = false;
  //     else if (!isValid) this.isValidPlan = false;
  //     else this.isValidPlan = true;
  //   } else {
  //     if (totalSum > 6) this.isValidPlan = false;
  //     else if (!isValid) this.isValidPlan = false;
  //     else this.isValidPlan = true;
  //   }
  // }

  checkNpdsMinAndMax() {
    this.isValidPlan = true;
    let minumumRequired = this.temp_npd_data.minimum_facings;
    let maximumPresent = 0;
    let npdsLength = this.npd_data_with_facings.length;
    for (let i = 0; i < npdsLength; i++) {
      let value = this.npd_data_with_facings[i].facings;
      maximumPresent += value;
      if (value !== 0 && value < minumumRequired) this.isValidPlan = false;
    }
    if (
      maximumPresent > this.maximum_npds_allowed ||
      maximumPresent < this.maximum_npds_allowed
    )
      this.isValidPlan = false;
  }

  decrement(i: number, key: string): void {
    this.npd_data_with_facings = this.npd_data_with_facings.map(
      (n: any, index: number) => {
        if (i == index && n.facings >= 1) {
          n.facings--;
        }
        return n;
      }
    );
    this.checkNpdsMinAndMax();
  }

  getRequriedDataForSpecificScreen = (
    stepper_index: number,
    planogam_id?: number,
    channel?: string
  ) => {
    switch (stepper_index) {
      case 0:
        if (planogam_id) {
          if (!this.getRequriedDataForSpecificScreen) this.stepper_index = 0;
          //this.getNPDData()
          //this.planogramState.getTemplates(planogam_id);
        }

        break;

      case 1:
        //let scenario = this.getScenario(channel);
        this.stepper_index = 1;
        break;

      case 2:
        //let scenario = this.getScenario(channel);
        if (planogam_id) {
          //this.planogramState.getSKUsListAndCoolerConfig(planogam_id, scenario);
          this.planogramState.fetchReviewSkuFacings({
            planogram_id: planogam_id,
          });
        }
        break;

      case 3:
        if (planogam_id) {
          // this.planogramState.getPlanogramDataAndCoolerConfig(planogam_id);
        }
        break;

      default:
        break;
    }
  };

  subscribeFormControls = () => {
    this.planogram_base_details_subscription =
      this.planogram_base_details.subscribe((p_b_d) => {
        this.temp_planogram_base_details = p_b_d;
        if (p_b_d && Object.keys(p_b_d).length > 0) {
          this.units = Object.keys(p_b_d);
          if (this.units && this.units.length > 0) {
            this.planogram_base_detail_form_group.controls['units'].enable();
          }
          this.channels = Object.keys(p_b_d[this.units[0]]);
          // if(this.channels && this.channels.length>0){
          //   this.planogram_base_detail_form_group.controls['channel'].enable();
          // }
          this.coolers = p_b_d[this.units[0]][this.channels[0]];
          // if(this.coolers && this.coolers.length>0){
          //   this.planogram_base_detail_form_group.controls['cooler_type'].enable();
          // }
        }

        // if (p_b_d.business_goals && p_b_d.business_goals.length > 0) {
        //   this.planogram_base_detail_form_group.controls[
        //     'business_goals'
        //   ].enable();
        // }
        // if (p_b_d.portfolio_selection && p_b_d.portfolio_selection.length > 0) {
        //   this.planogram_base_detail_form_group.controls[
        //     'portfolio_selection'
        //   ].enable();
        // }
        // if (p_b_d.channels && p_b_d.channels.length > 0) {
        //   this.planogram_base_detail_form_group.controls['channel'].enable();
        // }
        // if (p_b_d.units && p_b_d.units.length > 0) {
        //   this.planogram_base_detail_form_group.controls['units'].enable();
        // }
        // if (p_b_d.channels && p_b_d.channels.length > 0) {
        //   this.planogram_base_detail_form_group.controls['channel'].enable();
        // }
        // if (p_b_d.cooler_types && p_b_d.cooler_types.length > 0) {
        //   this.planogram_base_detail_form_group.controls['cooler_type'].enable();
        // }
        // if (p_b_d.sub_channel && p_b_d.sub_channel.length > 0) {
        //   this.planogram_base_detail_form_group.controls[
        //     'sub_channel'
        //   ].enable();
        // }
        // if (p_b_d.segment && p_b_d.segment.length > 0) {
        //   this.planogram_base_detail_form_group.controls['segment'].enable();
        // }
        // if (p_b_d.units && p_b_d.units.length > 0) {
        //   this.planogram_base_detail_form_group.controls[
        //     'units'
        //   ].enable();
        // }
        // if (p_b_d.cooler_types && p_b_d.cooler_types.length > 0) {
        //   this.planogram_base_detail_form_group.controls['cooler'].enable();
        // }
      });
  };

  selectedPlanogramBaseDataSubscription = () => {
    this.selected_planogram_base_data_subscription =
      this.selected_planogram_base_data.subscribe((data: any) => {
        if (data.name) {
          localStorage.setItem('channel', data.channel);
          // this.planogram_base_detail_form_group
          //   .get('planogram_name')
          //   ?.setValue(data.name);
          this.planogram_base_detail_form_group
            .get('planogram_name')
            ?.disable();
          this.planogram_base_detail_form_group
            .get('channel')
            ?.setValue(data.channel);
          this.planogram_base_detail_form_group
            .get('units')
            ?.setValue(data.unit);
          this.planogram_base_detail_form_group
            .get('cooler_type')
            ?.setValue(data.cooler_type);
          this.planogram_status = data.progress_status;
          // this.temp_npd_data=data.NPDs
          // this.npd_data_with_facings=data.NPDs.NPDs
          // this.maximum_npds_allowed=data.NPDs.max_facings
          // this.npds_max_message=`${this.maximum_npds_allowed ||""} NPD facing allowed`
          this.stepper_index = data.screen_id - 1;
          this.screen_index_completed = data.screen_id - 1;
          this.getRequriedDataForSpecificScreen(
            data.screen_id - 1,
            data.id,
            data.channel
          );
        }
      });
  };

  onBlurPlanogramName = () => {
    // let planogram_name = this.planogram_base_detail_form_group
    //   .get('planogram_name')
    //   ?.value.trim();
    // if (this.planogram_base_detail_form_group.get('planogram_name')?.valid) {
    //   this.planogramState.verifyPlanogramUniqueName(planogram_name);
    // }
  };

  isRequiredField = (field: string) => {
    const form_field = this.planogram_base_detail_form_group.get(
      field
    ) as AbstractControl;
    if (!form_field.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);
    return validator && validator['required'];
  };

  handleCoolerCheckbox = (event: MatCheckboxChange) => {
    let cooler_template_prev_value =
      this.cooler_template_form_group.get('cooler_template')?.value;
    let current_value = event.source.value;
    if (cooler_template_prev_value === event.source.value) {
      current_value = '';
    }
    this.cooler_template_form_group
      .get('cooler_template')
      ?.setValue(current_value);
  };

  handleChannelChange = (event: MatSelectChange) => {
    localStorage.setItem('channel', event.source.triggerValue);
    this.planogram_base_detail_form_group.get('cooler_type')?.setValue('');
    this.cooler_info = {};
    this.cooler_info_updated = [];
    if (!this.coolers) {
      this.planogram_base_detail_form_group.controls['cooler_type'].enable();
    }
    this.coolers =
      this.temp_planogram_base_details[
        this.planogram_base_detail_form_group.controls['units'].value
      ][this.planogram_base_detail_form_group.controls['channel'].value];
  };

  clearSelectionOnValueChange = (_event: any, form_control_name: string) => {
    this.planogram_base_detail_form_group.get(form_control_name)?.setValue('');
    this.cooler_info = {};
    this.cooler_info_updated;
    console.log(
      "planogram_base_detail_form_group?.controls?.['cooler_type']?.value?",
      this.planogram_base_detail_form_group?.controls?.['cooler_type']?.value
        .length
    );
    this.planogram_base_detail_form_group.get('cooler_type')?.setValue('');
    if (!this.channels)
      this.planogram_base_detail_form_group.controls['channel'].enable();
    this.channels = Object.keys(
      this.temp_planogram_base_details[
        this.planogram_base_detail_form_group.controls['units'].value
      ]
    );
  };

  clearSelectedCoolerInfo() {
    this.cooler_info = {};
    this.cooler_info_updated = [];
  }

  savePlanogramBaseDetails = (
    is_planogram_edit: boolean,
    edit_planogram_detail: any,
    screen_index: number,
    is_save_draft: boolean
  ) => {
    let planogram_info: PlanogramBaseDetailModal = {
      planogram_name: '',
      // this.planogram_base_detail_form_group.controls['planogram_name'].value,
      channel: this.planogram_base_detail_form_group.controls['channel'].value,
      unit: this.planogram_base_detail_form_group.controls['units'].value,
      cooler_type:
        this.planogram_base_detail_form_group.controls['cooler_type'].value,
      NPDs: this.npd_data_with_facings,
      max_facings: this.maximum_npds_allowed,
      min_facings: this.temp_npd_data.minimum_facings,

      // segment: this.planogram_base_detail_form_group.controls['segment'].value,
      // portfolio_selection:
      //   this.planogram_base_detail_form_group.controls['portfolio_selection']
      //     .value,
      // business_goal:
      //   this.planogram_base_detail_form_group.controls['business_goals'].value,
    };
    if (is_planogram_edit && !is_save_draft) {
      planogram_info.planogram_id = edit_planogram_detail.id;
      planogram_info.edit_flag = 1;
      if (!planogram_info.screen_index) {
        planogram_info.screen_index = screen_index;
      }
      this.planogramState.editPlanogramBaseDetails(
        planogram_info,
        !is_save_draft
      );
    } else if (is_save_draft) {
      //planogram_info.planogram_id = edit_planogram_detail.id;
      if (is_planogram_edit) {
        planogram_info.edit_flag = 1;
      }
      if (!planogram_info.screen_index) {
        planogram_info.screen_index = screen_index;
      }
      this.planogramState.setUpSaveAsDraftPlanogramBaseDetails(
        planogram_info,
        !is_save_draft
      );
    } else {
      planogram_info.screen_index = screen_index;
      this.planogramState.savePlanogramBaseDetails(
        planogram_info,
        !is_save_draft
      );
    }
  };

  handleCreateNewTemplateBtnClick = () => {
    this.create_new_template = true;
    this.planogramState.setSelectCoolerInfo({});
    this.edit_template_id = -1;
  };

  truncateNPDName(name: string) {
    if (name.length > 28) {
      return name.slice(0, 28) + '..';
    } else return name;
  }

  showToolTip(name: string) {
    if (name.length > 28) {
      return true;
    } else return false;
  }

  goToPreviousStep = (index: number) => {
    if (!isNaN(index)) {
      this.stepper_index = index;
    }
  };

  handleDiscardClick = (planogram_id: any, arrow_click?: boolean) => {
    const dialogRef = this.dialog.open(ConfirmDialogModalComponent, {
      height: '200px',
      width: '500px',
      data: {
        header_msg: 'Are you sure you want to cancel?',
        header_msg_description: 'All progress will be lost.',
        cancel_action: 'Cancel',
        ok_action: 'Continue',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (planogram_id !== undefined && !arrow_click) {
          this.planogramState.deletePlanogram(planogram_id);
        }
        this.goBack();
      }
    });
  };

  draftPlanogramDetails = (
    is_planogram_edit: boolean,
    edit_planogram_detail: any,
    step_index: number
  ) => {
    const dialogRef = this.dialog.open(ConfirmDialogModalComponent, {
      height: '200px',
      width: '500px',
      data: {
        header_msg: 'Save to Drafts',
        header_msg_description:
          'You can edit & publish the templates from draft later.',
        cancel_action: 'Cancel',
        ok_action: 'Okay',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.temp_stepper_index = step_index;
        this.apiCallToSavePlanogramBaseDetails(
          is_planogram_edit,
          edit_planogram_detail,
          step_index,
          true
        );
        this.is_go_back = true;
      }
    });
  };

  apiCallToSavePlanogramBaseDetails = (
    is_planogram_edit: boolean,
    edit_planogram_detail: any,
    step_index: number,
    is_save_draft: boolean
  ) => {
    let screen_index = is_save_draft
      ? this.stepper_index
      : this.stepper_index + 1;
    switch (step_index) {
      case 0:
        let channel =
          this.planogram_base_detail_form_group.controls['channel'].value;
        let unit =
          this.planogram_base_detail_form_group.controls['units'].value;
        let cooler_type =
          this.planogram_base_detail_form_group.controls[
            'cooler_type'
          ].value?.trim();
        let isNPDSelected =
          this.planogram_base_detail_form_group.controls[
            'npd_selection'
          ].value?.trim();
        this.planogramState.createBasePlanogram({
          channel: channel,
          unit: unit,
          cooler_type: cooler_type,
          npd_selection:
            CONFIG.NPD_SELECTION_OPTIONS[
              isNPDSelected as keyof typeof CONFIG.NPD_SELECTION_OPTIONS
            ],
        });
        // this.savePlanogramBaseDetails(
        //   is_planogram_edit,
        //   edit_planogram_detail,
        //   screen_index,
        //   is_save_draft
        // );
        this.stepper_index = 1;
        break;
      case 1:
        this.incorporateNpds();
        this.stepper_index = 2;
        break;
      case 2:
        if (is_save_draft) {
          this.router.navigateByUrl(CONFIG.PATH.PLANOGRAMS, {
            state: { screen_index: 0, from: 'landing' },
          });
        } else {
          this.savePlanogramSkuPlacement(
            edit_planogram_detail,
            screen_index,
            is_save_draft
          );
        }
        break;

      case 3:
        if (is_save_draft) {
          this.router.navigateByUrl(CONFIG.PATH.PLANOGRAMS, {
            state: { screen_index: 0, from: 'landing' },
          });
        }
        this.publishPlanogram(
          edit_planogram_detail,
          screen_index,
          is_save_draft
        );
        break;
      default:
        break;
    }
  };

  savePlanogramBaseDetailsAndNavigate = (
    is_planogram_edit: boolean,
    edit_planogram_detail: any,
    step_index: number
  ) => {
    this.is_save_detail_and_nevigate = true;
    this.temp_stepper_index = step_index + 1;
    this.apiCallToSavePlanogramBaseDetails(
      is_planogram_edit,
      edit_planogram_detail,
      step_index,
      false
    );
  };

  incorporateNpds() {
    this.guidelinesInputComponent.saveNpdsData();
  }

  setStepperIndex = (
    event: any,
    is_planogram_edit: boolean,
    edit_planogram_detail: any
  ) => {
    // if (!this.is_save_detail_and_nevigate) {
    this.updateStepperIndex(
      event.selectedIndex,
      is_planogram_edit,
      edit_planogram_detail,
      event.selectedIndex > event.previouslySelectedIndex
    );
    // }
  };

  updateStepperIndex = (
    index: number,
    is_planogram_edit: boolean,
    edit_planogram_detail: any,
    _get_screen_data: boolean
  ) => {
    this.stepper_index = index;
    this.isReset = false;
    localStorage.setItem('stepper_index', String(this.stepper_index));
    if (this.create_new_template) {
      this.create_new_template = false;
    }

    this.cooler_template_search_input = '';

    if (index === 0 && is_planogram_edit && edit_planogram_detail.id) {
      this.planogram_base_detail_form_group.get('planogram_name')?.disable();
    }
    this.getRequriedDataForSpecificScreen(index, edit_planogram_detail.id);
  };

  comparesegmentSelectedObjects(o1: any, o2: any) {
    if (o1.id == o2.id && o1.value === o2.value) return true;
    else return false;
  }

  goBack = () => {
    this.router.navigateByUrl(CONFIG.PATH.PLANOGRAMS, {
      state: { screen_index: 0, screen: 'planogram-list' },
    });
    this.planogramState.setPlanogramEdit(false, -1);
    this.planogramState.setSelectCoolerInfo({});
  };

  templateCreateBackEvent = (is_create: boolean) => {
    this.create_new_template = is_create;
    this.edit_template_id = -1;
  };

  templateCreateBackAndNextScreenNavigateEventHandle = (event_params: {
    is_success: boolean;
    cooler_id: number;
  }) => {
    if (event_params.is_success) {
      this.create_new_template = false;
      this.edit_template_id = -1;
      this.planogramState.getTemplates(this.edit_planogram_detail.id);
      this.cooler_template_form_group.controls['cooler_template'].setValue(
        event_params.cooler_id
      );
    }
  };

  editTemplate(template: any) {
    this.create_new_template = true;
    this.edit_template_id = template.id;
    this.planogramState.setSelectCoolerInfo({
      id: template.id,
      template_name: template.name,
    });
  }

  getCoolerDetails() {
    let channel =
      this.planogram_base_detail_form_group.controls['channel'].value;
    let unit = this.planogram_base_detail_form_group.controls['units'].value;
    let cooler_type =
      this.planogram_base_detail_form_group.controls[
        'cooler_type'
      ].value?.trim();
    this.planogramState.getCoolerInfo({
      channel: channel,
      unit: unit,
      cooler_type: cooler_type,
    });
    this.cooler_info_subscribtion = this.cooler_info_observable.subscribe(
      (res) => {
        this.cooler_info = res;
        let noOfCoolers = Object.keys(res['dimensions']);
        let dimension = Object.values(res['dimensions']);
        let shelves = Object.values(res['shelves']);
        let product_facing = Object.values(res['product_facings']);
        let shelf_config = Object.values(res['shelf_configs']);
        let cooler_data = [];
        for (let i = 0; i < noOfCoolers.length; i++) {
          let obj: any = {};
          obj.name = noOfCoolers[i];
          obj.dimension = dimension[i];
          obj.shelf = shelves[i];
          obj.product_facings = product_facing[i];
          obj.shelf_config = shelf_config[i];
          cooler_data.push(obj);
        }
        this.cooler_info_updated = cooler_data;
        console.log('this.cooler_info_updated', this.cooler_info_updated);
        console.log('res cooler', res);
        this.getImages(res['cooler_image_uri']);
      }
    );
  }

  saveCoolerToPlanogram(
    edit_planogram_detail: any,
    screen_index: number,
    is_save_draft: boolean
  ) {
    if (edit_planogram_detail.id !== undefined) {
      let info = {
        screen_index: screen_index,
        planogram_id: edit_planogram_detail.id,
        template_id:
          this.cooler_template_form_group.controls['cooler_template'].value,
      };
      this.planogramState.saveTemplateToPlanogram(info, !is_save_draft);
    }
  }

  /**
   *
   * @param edit_planogram_detail
   * @param screen_index
   * @param is_save_draft
   * async is used for blob file generation
   */
  async savePlanogramSkuPlacement(
    edit_planogram_detail: any,
    screen_index: number,
    is_save_draft: boolean = true
  ) {
    if (edit_planogram_detail.id !== undefined) {
      let info = {
        screen_index: screen_index,
        id: edit_planogram_detail.id,
        // placed_skus: this.planogram_placed_skus.map((s) => {
        //   return {
        //     sku_id: s.sku_id,
        //     sku_position: s.position,
        //     shelf: s.shelf,
        //     door: s.door,
        //     height: s.sku_height,
        //     width: s.sku_width_calc,
        //     block: s.block,
        //     volume: s.sku_volume,
        //     ic_fc: s.ic_fc,
        //   };
        // }),
        // sku_details: getPlacedSkuDetail(this.planogram_placed_skus),
        // vertical_orientation_flag: this.vertical_cooler_orientation,
        // vertical_brand_association: this.vertical_cooler_orientation
        //   ? this.vertical_brand_association
        //   : {},
      };

      // let name =
      //   this.planogram_base_detail_form_group.get('planogram_name')?.value;
      let cooler =
        this.planogram_base_detail_form_group.get('cooler_type')?.value;
      this.planogramState.savePlanogramSkuPlacement(
        info,
        true,
        // name,
        cooler,
        edit_planogram_detail.id
      );
    }
  }

  publishPlanogram(
    edit_planogram_detail: any,
    _screen_index: number,
    is_save_draft: boolean = true
  ) {
    if (edit_planogram_detail.id !== undefined) {
      let info = {
        id: edit_planogram_detail.id,
        // screen_id: 2,
        // status: is_save_draft ? 'draft' : 'publish',
        // planogram_image: getPlanogramImageUrl(
        //   edit_planogram_detail.id,
        //   this.planogram_base_detail_form_group.get('planogram_name')?.value,
        //   false
        // ),
      };

      this.planogramState.publishPlanogram(info);
    }
  }

  displayCoolerShelfConfig(shelf_config: any): any[] {
    console.log('shelf_config', shelf_config);
    let keys = Object.keys(shelf_config);
    return keys;
  }

  filledSkuEvent(sku_flled: number) {
    this.add_sku_form_group.get('filled_sku')?.setValue(sku_flled);
  }

  skuPlacementFlagUpdate(is_change: boolean) {
    this.sku_placement_change = is_change;
  }

  businessInsightCalculationEvent(business_insight_cal: any) {
    this.add_sku_form_group
      .get('volume')
      ?.setValue(business_insight_cal.volume);
    this.add_sku_form_group
      .get('revenue')
      ?.setValue(business_insight_cal.revenue);
    this.add_sku_form_group
      .get('profit')
      ?.setValue(business_insight_cal.profit);
    this.add_sku_form_group
      .get('transaction')
      ?.setValue(business_insight_cal.transaction);
  }

  sortTemplates(saved_templates: any[]) {
    let selected_template_id =
      this.cooler_template_form_group.get('cooler_template')?.value;
    if (
      this.saved_templates.length > 0 &&
      !isNaN(selected_template_id) &&
      this.saved_templates[0].id !== selected_template_id
    ) {
      let index = this.saved_templates.findIndex(
        (t) => t.id === selected_template_id
      );
      if (index !== -1) {
        let selected_template = this.saved_templates[index];
        this.saved_templates.splice(index, 1);
        this.saved_templates.unshift(selected_template);
      }
      document.getElementById('templates-container')?.scrollTo({ top: 0 });
    }

    return saved_templates;
  }

  getUniqueValues = (source: PlanogramSegmentEntityModal[], key: string) => {
    if (source && source.length > 0) {
      return [...new Map(source.map((s: any) => [s[key], s])).values()];
    }
    return [];
  };

  updateVerticalColumnBrandAssociation = (brand_association: any) => {
    this.vertical_brand_association = brand_association;
  };

  updateCoolerOrientation = (orientation: boolean) => {
    this.vertical_cooler_orientation = orientation;
  };

  resetPlanogram(event: any) {
    this.isReset = event.reset;
  }

  checkNpdsValidationInGuidelines(event: any) {
    this.npds_data_valid = event.valid;
    console.log('this.npds_data_valid=========>', this.npds_data_valid);
  }
}
